export enum InputType {
  Number = 'number',
  Slider = 'slider',
  RadioGroup = 'radioGroup',
  Dropdown = 'dropdown',
  Timer = 'timer',
  Checkbox = 'checkbox',
  Special = 'special', // Für spezielle Eingaben wie NHPT
}

export enum CalculationType {
  Sum = 'sum', // Einfache Summe
  NormValueComparison = 'normValueComparison', // Vergleich mit Normwerten
  DirectICFMapping = 'directICFMapping', // Direkte Zuordnung zu ICF-Scores
  Interpolation = 'interpolation', // Interpolation für Prozentwerte
}

export enum SideType {
  None = 'none',
  Left = 'left',
  Right = 'right',
  Both = 'both',
}

export interface ICFCategory {
  code: string;
  description: string;
}

export interface InputOption {
  value: number | string;
  label: string;
  description?: string;
}

export interface TaskDefinition {
  id: string;
  title: string;
  description?: string;
  guide?: string; // HTML-String für Hilfe
  inputType: InputType;
  options?: InputOption[];
  minValue?: number;
  maxValue?: number;
  step?: number;
  defaultValue?: number | string | null; // Geändert: null hinzugefügt
  icfCategories?: ICFCategory[];
  calculationWeight?: number; // Gewichtung für die Berechnung
  sideType?: SideType;
  isRequired?: boolean;
  specialConfig?: any; // Für spezielle Konfigurationen (z.B. NHPT)
  sortOptionsReversed?: boolean; // Ob Optionen in umgekehrter Reihenfolge angezeigt werden sollen (4-0 statt 0-4)
}

export interface GroupDefinition {
  id: string;
  title: string;
  description?: string;
  guide?: string; // HTML-String für Hilfe
  tasks: TaskDefinition[];
  icfCategories?: ICFCategory[];
  calculationType?: CalculationType;
  calculationLogic?: string; // Logik für die Berechnung als String (kann evaluiert werden)
}

export interface NormValue {
  gender: string;
  minAge: number;
  maxAge: number;
  avgValue: number;
  stdDeviation: number;
  calculationFormula?: string; // Formel für komplexere Berechnungen
  calculationMethod?: string; // Add this new property for the named calculation methods
}

export interface AssessmentDefinition {
  id: string;
  version: string;
  name: string;
  shortName: string;
  description: string;
  guide?: string; // HTML-String für Hilfe
  groups: GroupDefinition[];
  icfCategories?: ICFCategory[];
  calculationType: CalculationType;
  calculationLogic?: string; // Logik für die Berechnung als String (kann evaluiert werden)
  normValues?: NormValue[]; // Normwerte für Vergleiche
  requiresPatientData?: boolean; // Ob Patientendaten erforderlich sind (Alter, Geschlecht, etc.)
  sideType?: SideType; // Ob Seitenunterscheidung benötigt wird
  showPercentFulfillment?: boolean; // Prozent der Erfüllung anzeigen
  showICFScore?: boolean; // ICF-Score anzeigen
}
